import {
  GET_CAREER_MENTORSHIP,
  UPDATE_CAREER_MENTORSHIP,
} from '../../Constant/ActionTypes';

const initialState = {
  allCareerMentorships: false,
  isUpdateCareerMentorship: false,
};
const careerMentorshipReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAREER_MENTORSHIP:
      return {
        ...state,
        allCareerMentorships: action.payload,
      };
    case UPDATE_CAREER_MENTORSHIP:
      return {
        ...state,
        isUpdateCareerMentorship: true,
        allCareerMentorships: false,
      };
    default:
      return state;
  }
};

export default careerMentorshipReducer;
